"use client";
import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { featureTabs } from "./data";
import FeaturePreview from "./FeaturePreview";

export default function ScrollStoppingCopy() {
  const [activeTab, setActiveTab] = useState(0);
  const active = featureTabs[activeTab];

  return (
    <div className="px-6 md:px-[40px] xl:px-20 pt-12 lg:pt-20 pb-16">
      <h2 className="solution-sub-heading">Scroll-Stopping Copy, Fast</h2>

      {/* tabs */}
      <div
        className="
    mt-8 py-2 px-2
 lg:px-1 flex gap-3
    overflow-x-auto
    snap-x snap-mandatory
    scroll-smooth
    scroll-pl-4
    [scrollbar-width:none]
    [-ms-overflow-style:none]
    [&::-webkit-scrollbar]:hidden
  "
      >
        {featureTabs.map((t, i) => {
          const isActive = i === activeTab;

          return (
            <button
              key={t.id}
              onClick={() => setActiveTab(i)}
              className={`inline-flex shrink-0 snap-start items-center gap-1.5 sm:gap-2 whitespace-nowrap rounded-full px-3 py-1.5 text-[12px] sm:px-4 sm:py-2.5 sm:text-[14px] font-medium transition-colors ${
                isActive
                  ? "bg-white text-[#1a1a1a] ring-1 ring-[#1a1a1a]"
                  : "bg-white text-[#78716C] ring-1 ring-[#E7E5E4] hover:text-[#1a1a1a] hover:ring-[#D6D3D1]"
              }`}
            >
              <span>{t.tab.icon}</span>
              {t.tab.label}
            </button>
          );
        })}
      </div>

      {/* active panel */}
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 overflow-hidden rounded-[24px] ring-1 ring-[#ECEAE8]">
        {/* left */}
        <div className="p-6 md:p-8 lg:p-12 bg-white">
          <span className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-[12px] font-semibold text-[#1a1a1a] ring-1 ring-[#ECEAE8]">
            <span>{active.tab.icon}</span>
            {active.badge}
          </span>

          <h3 className="mt-6 text-[28px] lg:text-[34px] font-bold leading-[1.15] text-[#1C1917]">
            {active.heading}
          </h3>

          <p className="mt-4 text-[14px] lg:text-[16px] leading-[1.6] text-[#78716C]">
            {active.description}
          </p>

          <ul className="mt-7 space-y-3.5">
            {active.checklist.map((c) => (
              <li key={c} className="flex items-center gap-3">
                <span className="grid h-4 w-4 shrink-0 place-items-center rounded-full bg-[#1a1a1a]">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path
                      d="M2.5 6.2 4.8 8.5 9.5 3.5"
                      stroke="white"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className=" text-[12px] lg:text-[16px] text-[#292929]">
                  {c}
                </span>
              </li>
            ))}
          </ul>

          <a
            href="https://app.imagive.ai?redirect=/users/white-chat-board"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 group inline-flex items-center gap-2 text-[12px] lg:text-[14px] font-semibold text-[#1a1a1a] hover:gap-3 transition-all"
          >
            {active.cta}{" "}
            <ArrowRight
              size={16}
              className="transition-all group-hover:translate-x-1 duration-300 "
            />
          </a>
        </div>

        {/* right */}
        <div className="flex items-center justify-center p-4 md:p-8 lg:p-12 bg-[#FAFAF9] border-t lg:border-t-0 lg:border-l border-[#ECEAE8]">
          <div className="w-[400px] 2xl:w-[600px]">
            <FeaturePreview preview={active.preview} />
          </div>
        </div>
      </div>
    </div>
  );
}
